import { Button, Flex, Heading, Paragraph } from "@ir/ui";
import { type BreadcrumbItem } from "@src/presentation/components/common";
import { PageHeader } from "@src/presentation/components/Layout/common";
import HasAnyPermission from "@src/presentation/components/permissions/HasAnyPermission";
import { Permissions } from "@src/domain/permissions";
export interface UserDetailsHeaderProps {
  breadcrumbItems: BreadcrumbItem[];
  title: string;
  subtitle?: string;
  onEditUserClick?: () => void;
  isEditUserDisabled?: boolean;
  onSaveChanges: () => void;
  isSaveDisabled?: boolean;
  isSaveLoading?: boolean;
}

export const UserDetailsHeader = ({
  breadcrumbItems,
  title,
  subtitle = "Manage user profile and brand permissions",
  onEditUserClick,
  isEditUserDisabled = false,
  onSaveChanges,
  isSaveDisabled = true,
  isSaveLoading = false,
}: Readonly<UserDetailsHeaderProps>) => {
  return (
    <PageHeader breadcrumb={{ items: breadcrumbItems }}>
      <Flex align="center" justifyContent="space-between" gap={1}>
        <Flex direction="column">
          <Heading level={5} className="text-grey-700 font-bold m-0">
            {title}
          </Heading>
          <Paragraph className="text-grey-500 m-0">{subtitle}</Paragraph>
        </Flex>
        <Flex align="center" gap={0.75}>
          <HasAnyPermission
            requiredPermissions={[Permissions.USER_MANAGEMENT_EDIT]}
          >
            {onEditUserClick && (
              <Button
                size="small"
                variant="outline"
                onPress={onEditUserClick}
                isDisabled={isEditUserDisabled}
              >
                Edit User
              </Button>
            )}
            <Button
              size="small"
              color="primary"
              onPress={onSaveChanges}
              isDisabled={isSaveDisabled}
              isLoading={isSaveLoading}
            >
              Save Changes
            </Button>
          </HasAnyPermission>
        </Flex>
      </Flex>
    </PageHeader>
  );
};
